import React, { useContext, useEffect, useState } from 'react';
import TableLogReferral from "components/TableLogReferral";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../config/axios";
import { useDebouncedCallback } from 'use-debounce';
import { RootContext } from '../../App';
import refactorStructureData from '../../helpers/refactorDataMenu';
export default function LogReferral() {
  const history = useHistory();
  const [logReferral, setLogReferral] = useState()
  const [pending, setPending] = useState(true);
  const [username, setUsername] = useState(null)
  const [adminUsername, setAdminUsername] = useState(null)
  const [length, setLength] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0);
  const { state, setState } = useContext(RootContext)
  const debounced = useDebouncedCallback( (action) => { action() }, 200 );

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, adminUsername, currentPage, length])

  const getData = () => {
    const token = localStorage.getItem("access_token");
    const group = JSON.parse(localStorage.getItem("group"))

    if (!token) {
      history.push("/login");
    } else {
      try {
        axiosInstance("log_referral", {
          method: "POST",
          data: {
            token: token,
            group: group.wbid,
            username: username,
            admin_user: adminUsername,
            perPage: length,
            page: currentPage
          },
        })
          .then((res) => {
            setLogReferral(res.data.data.list);
            setPending(false);
            setTotalRows(res.data.data.add_data.total_row);

            setState({
              ...state,
              group: res.data.data.additional_data.group,
              menu: refactorStructureData(res.data.data.additional_data.menu),
            });
          })
          .catch((err) => { });
      } catch (error) {
        console.log("ERROR: ", error);
      }
    }
  };

  return (
    <>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto">
      </div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <TableLogReferral pending={pending} title="Log Referral" logReferral={logReferral}
              totalRows={totalRows}
              usernameEvent={(event) => {
                debounced(() => setUsername(event.target.value))
              }}
              adminUsernameEvent={(event) => {
                debounced(() => setAdminUsername(event.target.value))
              }}
              onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                setLength(currentRowsPerPage)
              }}
              handlePageChange={(page) => {
                setCurrentPage(page);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}